import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-screen bg-gradient-to-b from-cream-100 via-cream-200 to-cream-300 overflow-hidden" data-id="element-59">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30" data-id="element-60">
        <div className="absolute top-20 left-10 w-32 h-32 bg-gold-300 rounded-full blur-3xl" data-id="element-61" />
        <div className="absolute bottom-40 right-20 w-48 h-48 bg-gold-400 rounded-full blur-3xl" data-id="element-62" />
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-amethyst-200 rounded-full blur-2xl" data-id="element-63" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 py-16 md:py-24" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center text-center" data-id="element-65">
          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mb-8 w-full max-w-2xl" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/peXWNSooJymPz3wPwiCqcF/manifiesta_en_armonia.png" alt="Manifiesta en Armonía - Guía de 12 módulos para manifestar abundancia con autoestima" className="w-full h-auto rounded-2xl shadow-2xl shadow-gold-600/20" data-id="element-67" />
          </motion.div>

          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="font-heading text-4xl md:text-5xl lg:text-6xl text-brown-700 mb-2" data-id="element-68">
            <span className="italic" data-id="element-69">Manifiesta en Armonía</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="font-heading text-2xl md:text-3xl text-gold-600 font-semibold mb-6" data-id="element-70">
            Expansión Completa
          </motion.p>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="text-lg md:text-xl text-brown-500 mb-8 max-w-xl" data-id="element-71">
            Guía profunda y práctica · 12 módulos · Abundancia + Autoestima
          </motion.p>

          {/* Author */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} className="text-brown-400 mb-8" data-id="element-72">
            Por{' '}
            <span className="font-semibold text-brown-600" data-id="element-73">
              Rebeca Rodriguez
            </span>
          </motion.p>

          {/* Price Badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.8
        }} className="flex items-center gap-3 bg-white/60 backdrop-blur-sm px-6 py-3 rounded-full mb-8 shadow-lg" data-id="element-74">
            <SparklesIcon className="w-5 h-5 text-gold-500" data-id="element-75" />
            <span className="text-lg text-brown-400 line-through" data-id="element-76">USD $19</span>
            <span className="text-2xl font-bold text-gold-600" data-id="element-77">USD $6</span>
            <span className="bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-78">
              -68%
            </span>
          </motion.div>

          {/* CTA Button */}
          <motion.a href="https://www.escueladigitallidera.com//cart/48324707025115:1" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.9
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} className="inline-flex items-center gap-2 bg-gradient-to-r from-gold-500 to-gold-600 text-white font-bold text-lg px-10 py-4 rounded-full shadow-xl shadow-gold-500/30 hover:shadow-gold-500/50 transition-shadow duration-300" data-id="element-79">
            Quiero mi PDF ahora
          </motion.a>

          {/* Format note */}
          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 1
        }} className="mt-6 text-sm text-brown-400" data-id="element-80">
            PDF descargable · Acceso inmediato
          </motion.p>
        </motion.div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-81">
        <svg className="relative block w-full h-16 md:h-24" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-82">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C57.1,118.92,156.63,69.08,321.39,56.44Z" fill="#FFFDFB" data-id="element-83" />
        </svg>
      </div>
    </section>;
}